import { render, staticRenderFns } from "./ExampleView.vue?vue&type=template&id=12dc24b0&scoped=true&"
import script from "./ExampleView.vue?vue&type=script&lang=js&"
export * from "./ExampleView.vue?vue&type=script&lang=js&"
import style0 from "./ExampleView.vue?vue&type=style&index=0&id=12dc24b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc24b0",
  null
  
)

export default component.exports